import update from "immutability-helper";
import { ActionType, getType } from "typesafe-actions";
import * as errorHandling from "./error-handling-actions";
import { ErrorSeverity } from "~/types/errorTypes";

export type ErrorHandlingAction = ActionType<typeof errorHandling>;

export interface IErrorState {
    readonly showErrorInModal: boolean;
    readonly showErrorInline: boolean;
    readonly modalError?: string;
    readonly generalFormError?: string;
    readonly errorSeverity?: ErrorSeverity;
}

const initialState: IErrorState = {
    showErrorInModal: false,
    showErrorInline: false
};

const errorHandlingReducer = (state: IErrorState = initialState, action: ErrorHandlingAction) => {
    switch (action.type) {
        case getType(errorHandling.showErrorModal):
            return update(state, {
                showErrorInModal: { $set: true },
                modalError: { $set: action.payload.errorMessage }
            });
        case getType(errorHandling.hideErrorModal):
            return update(state, {
                showErrorInModal: { $set: false },
                modalError: { $set: undefined }
            });
        case getType(errorHandling.showErrorInline):
            return update(state, {
                showErrorInline: { $set: true },
                generalFormError: { $set: action.payload.errorMessage }
            });
        case getType(errorHandling.setErrorSeverityType):
            return update(state, {
                errorSeverity: { $set: action.payload.errorSeverity }
            });
        case getType(errorHandling.resetErrors):
            return update(state, {
                modalError: { $set: undefined },
                generalFormError: { $set: undefined }
            });
        default:
            return state;
    }
};

export default errorHandlingReducer;
